module.exports = __webpack_public_path__ + "img/waitServer.9614064b.png";